import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { KeyValue } from '@shared/interfaces/key-value/key-value';
import { enumToKeyValue } from '@app/core/utils/enum-to-key-value';
import { BusinessRole, PartyService } from '@app/api/dmc';
import { FormApiService } from '@app/core/services/form-api.service';
import { InputDirective } from '@shared/components/input/input/input.directive';
import { InputGroupComponent } from '@shared/components/input/input-group/input-group.component';
import { LabelDirective } from '@shared/components/input/label/label.directive';
import { TranslatePipe } from '@ngx-translate/core';
import { isoToDate } from '@app/core/utils/iso-to-date';
import { sortByTranslation } from '@app/core/utils/sort-by-translation';
import { SelectDirective } from '@shared/components/input/select/select.directive';
import { HasUnsavedChanges } from '@app/core/guards/unsaved-changes.guard';

@Component({
  selector: 'app-edit-actor-modal',
  imports: [
    InputDirective,
    InputGroupComponent,
    LabelDirective,
    ReactiveFormsModule,
    TranslatePipe,
    SelectDirective
  ],
  templateUrl: './edit-actor-modal.component.html',
  styleUrl: './edit-actor-modal.component.css'
})
export class EditActorModalComponent implements OnInit, HasUnsavedChanges {
  /** Form **/
  public hasUnsavedChanges(): boolean {
    return this.form.dirty;
  }

  public form: FormGroup = new FormGroup({
    id: new FormControl(null, Validators.required),
    businessRole: new FormControl(null, Validators.required),
    name: new FormControl(null, Validators.required),
    identification: new FormControl(null, Validators.required),
    terminationDate: new FormControl(null),
  });

  /** Business role **/
  public businessRoleList: KeyValue[] = sortByTranslation(enumToKeyValue(BusinessRole, { omitKeys: ['NotSpecified'], prefixValue: 'actor.businessrole.' }));
  /** ID **/
  public id?: string;

  constructor(
    private readonly partyService: PartyService,
    private readonly formApiService: FormApiService,
  ) {

  }

  public ngOnInit(): void {
    if (this.id) {
      this.partyService.partyGetByIdGet(this.id).subscribe((result) => {
        this.form.patchValue({
          ... result,
          terminationDate: result.terminationDate ? isoToDate(result.terminationDate) : null }
        );
      })
    }
  }

  public submit(): void {
    this.formApiService.submit(
      this.form,
      (data) => this.partyService.partyEditActorRegisterPost(data),
      {
        closeModal: true,
        successMessage: 'actorregister.edit.success'
      }
    )
  }

}
